import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MessageRoutingModule } from './message-routing.module';



@NgModule({
  
  imports: [
    CommonModule,
    MessageRoutingModule
  ]
})
export class MessageModule { }
